"use client";

import { TitleH2 } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const FurnitureOption = () => {
  const tC = useTranslations("common");
  const tH = useTranslations("floorPlanDesigns.furnitureOption");
  const rows = [
    {
      area: tC("diningRoom"),
      option: tC("tableChairs"),
    },
    {
      area: tC("livingRoom"),
      option: tH("tbody"),
    },
    {
      area: tC("balcTerace"),
      option: tC("outsideChairs"),
    },
    {
      area: tC("bedroom"),
      option: tH("tbody1"),
    },
  ];

  return (
    <div className="bg-secondary">
      <div className="gs--page-column py-16">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-5">
            <TitleH2 title={tH("title")} />
            <p className="text-ring">{tH("text")}</p>
            <p className="text-ring">{tH("text2")}</p>
          </div>
          <div className="flex flex-col gap-5">
            <p className="text-ring">{tH("text3")}</p>

            <div className="grid gap-3 md:hidden">
              {rows.map((row) => (
                <div
                  key={row.area}
                  className="border-input bg-background flex flex-col gap-2 rounded-md border p-4 shadow-sm"
                >
                  <span className="text-primary text-sm font-semibold">
                    {row.area}
                  </span>
                  <span className="text-ring text-sm leading-relaxed">
                    {row.option}
                  </span>
                </div>
              ))}
            </div>

            <div className="hidden w-full overflow-hidden rounded-md shadow-lg md:block">
              <table className="w-full table-auto border-collapse">
                <thead className="bg-primary text-white">
                  <tr>
                    <th className="border-spacing-0 p-5 text-left font-medium">
                      {tC("area")}
                    </th>
                    <th className="border-spacing-0 p-5 text-left font-medium">
                      {tC("option")}
                    </th>
                  </tr>
                </thead>

                <tbody className="bg-background">
                  {rows.map((row, index) => (
                    <tr
                      key={row.area}
                      className={
                        index % 2 === 0 ? "bg-muted border-b" : "border-b"
                      }
                    >
                      <td className="text-ring py-4 pl-5 font-medium">
                        {row.area}
                      </td>
                      <td className="text-ring py-4 pl-5">{row.option}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FurnitureOption;
